// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-page .login-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: calc(100vh - 74px);
  background-color: var(--background);
}

.login-page .login-form {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  background-color: var(--background-consistent);
  border-radius: 0.5rem;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
  text-shadow: 0px 0px 1px rgba(0, 0, 0, 0.1);
  font-size: 1rem;
  max-height: calc(100vh - 210px); /* Adjust this value based on the height of the navbar */
  overflow-y: auto;
}

.login-form input {
  width: 100%;
  padding: 1rem;
  margin-bottom: 1rem;
  border: none;
  border-radius: 0.25rem;
  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.1);
  text-shadow: 0px 0px 1px rgba(0, 0, 0, 0.1);
}

.login-form .login-submit-btn {
  width: 100%;
  padding: 0.5rem;
  margin: 1rem 0rem 1rem 0rem;
  background-color: var(--theme-consistent);
  color: #ffffff;
  border: none;
  border-radius: 0.25rem;
  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.1);
  text-shadow: 0px 0px 1px rgba(0, 0, 0, 0.1);
  cursor: pointer;
}

.login-form input,
.login-form .login-submit-btn,
.plex-login-container {
  width: 100%;
  max-width: 400px;
}

.login-form h2 {
  margin-bottom: 1.5rem;
}

.login-form .login-submit-btn:hover {
  background-color: var(--theme-consistent);
}

.login-error {
  color: #FF3A31;
  margin-top: 1rem;
  text-align: center;
  text-shadow: 0px 0px 1px rgba(0, 0, 0, 0.1);
  width: 70vw;
}

.signup-link {
  text-decoration: none;
  color: var(--theme-consistent);
  text-shadow: 0px 0px 1px rgba(0, 0, 0, 0.1);
}

.loginsignup-container {
  color: var(--theme-consistent);
  text-align: center;
  margin: 0.25rem;
}

.loginsignup-container .noaccount {
  color: var(--text-primary);
}

.forgot-password-link a {
  text-decoration: none;
  color: var(--theme-consistent);
}
`, "",{"version":3,"sources":["webpack://./src/assets/Login.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,8BAA8B;EAC9B,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,8CAA8C;EAC9C,qBAAqB;EACrB,2CAA2C;EAC3C,2CAA2C;EAC3C,eAAe;EACf,+BAA+B,EAAE,wDAAwD;EACzF,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,sBAAsB;EACtB,0CAA0C;EAC1C,2CAA2C;AAC7C;;AAEA;EACE,WAAW;EACX,eAAe;EACf,2BAA2B;EAC3B,yCAAyC;EACzC,cAAc;EACd,YAAY;EACZ,sBAAsB;EACtB,0CAA0C;EAC1C,2CAA2C;EAC3C,eAAe;AACjB;;AAEA;;;EAGE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,2CAA2C;EAC3C,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,8BAA8B;EAC9B,2CAA2C;AAC7C;;AAEA;EACE,8BAA8B;EAC9B,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;EACrB,8BAA8B;AAChC","sourcesContent":[".login-page .login-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  min-height: calc(100vh - 74px);\n  background-color: var(--background);\n}\n\n.login-page .login-form {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 2rem;\n  background-color: var(--background-consistent);\n  border-radius: 0.5rem;\n  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);\n  text-shadow: 0px 0px 1px rgba(0, 0, 0, 0.1);\n  font-size: 1rem;\n  max-height: calc(100vh - 210px); /* Adjust this value based on the height of the navbar */\n  overflow-y: auto;\n}\n\n.login-form input {\n  width: 100%;\n  padding: 1rem;\n  margin-bottom: 1rem;\n  border: none;\n  border-radius: 0.25rem;\n  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.1);\n  text-shadow: 0px 0px 1px rgba(0, 0, 0, 0.1);\n}\n\n.login-form .login-submit-btn {\n  width: 100%;\n  padding: 0.5rem;\n  margin: 1rem 0rem 1rem 0rem;\n  background-color: var(--theme-consistent);\n  color: #ffffff;\n  border: none;\n  border-radius: 0.25rem;\n  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.1);\n  text-shadow: 0px 0px 1px rgba(0, 0, 0, 0.1);\n  cursor: pointer;\n}\n\n.login-form input,\n.login-form .login-submit-btn,\n.plex-login-container {\n  width: 100%;\n  max-width: 400px;\n}\n\n.login-form h2 {\n  margin-bottom: 1.5rem;\n}\n\n.login-form .login-submit-btn:hover {\n  background-color: var(--theme-consistent);\n}\n\n.login-error {\n  color: #FF3A31;\n  margin-top: 1rem;\n  text-align: center;\n  text-shadow: 0px 0px 1px rgba(0, 0, 0, 0.1);\n  width: 70vw;\n}\n\n.signup-link {\n  text-decoration: none;\n  color: var(--theme-consistent);\n  text-shadow: 0px 0px 1px rgba(0, 0, 0, 0.1);\n}\n\n.loginsignup-container {\n  color: var(--theme-consistent);\n  text-align: center;\n  margin: 0.25rem;\n}\n\n.loginsignup-container .noaccount {\n  color: var(--text-primary);\n}\n\n.forgot-password-link a {\n  text-decoration: none;\n  color: var(--theme-consistent);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
